
import { Event as EventIcon } from '@mui/icons-material';
import { IconButton, styled, TextField } from '@mui/material';

export const StyledActionButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '2px',
  right: 0,
  padding: theme.spacing(0.5),
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const StyledCalendarIcon = styled(EventIcon)(({ theme }) => ({
  fill: `${theme.palette.primary.dark} !important`,
  fontSize: '1.2rem',
}));

export const HiddenTextField = styled(TextField)({
  position: 'absolute',
  top: 0,
  right: 0,
  width: '32px',
  height: '32px',
  opacity: 0,
  pointerEvents: 'none',
  '& .MuiInputBase-root': {
    width: '32px',
    height: '32px',
  },
  '& .MuiInputBase-input': {
    width: '32px',
    height: '32px',
    padding: 0,
  },
});
